import "./NlpSideBarCustomersList.css";
import React, {useEffect, useState} from "react";
import NlpSideBarCustomerItem from "./NlpSideBarCustomerItem/NlpSideBarCustomerItem";

const NlpSideBarCustomersList: React.FC = () => {

    return (
        <div className="NlpSideBarCustomersList">
            <NlpSideBarCustomerItem></NlpSideBarCustomerItem>
        </div>
    );
};

export default NlpSideBarCustomersList;
